<template>
  <div>
    <p class="cm-mg-p-wzd">
      3.1 {{ $t('common_words.calendar_companies_farm') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }}*</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.business_ids', businesses)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.business_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`${option.id}_${option.name}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_one_or_many_farms') }} *</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.farm_ids', farms)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select required-farms shadow-sm"
            size="large"
            v-model="model.farm_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in farms"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`${option.id}_${option.name}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        business_ids: null,
        farm_ids: null,
      },
      businesses: [],
      farms: null,
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);

          let others = [];
          this.businesses.forEach((item) => {
            this.model.business_ids.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          let othersF = [];
          this.farms.forEach((item) => {
            this.model.farm_ids.forEach((element) => {
              if (element == item.id) {
                othersF.push(item.name);
              }
            });
          });

          this.$emit('fillCalendarForm', 'thirdStep', {
            names_business: others,
            names_farms: othersF,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return false;

          if (this.model.business_ids.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
            return false;
          } else if (this.model.farm_ids.length == 0) {
            return this.validationInputsRequired('farms');
          } else return true;
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('businesses'),
        Axios.getMasters('farms/farms/'),
      ])
        .then((response) => {
          const [responseBusiness, responseFarms] = response;
          this.businesses = this.concatAll(responseBusiness.data.data);
          this.farms = this.concatAll(responseFarms.data.data);

          if (!sessionStorage.getItem('editForm')) {
            this.model.business_ids = this.selectElementsAsignFromModel(
              1,
              this.model.business_ids,
              this.businesses
            );

            if (
              this.model.business_ids === null &&
              this.businesses.length == 1
            ) {
              this.model.business_ids.push(this.businesses[0].id);
            }

            if (this.farms.length == 1)
              this.model.farm_ids.push(this.farms[0].id);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.business_ids = editForm.business_ids;
      this.model.farm_ids = editForm.farm_ids;
    }
  },
};
</script>
<style></style>
